/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Impressum_Copyright_TitleInputs */

const en_impressum_copyright_title = /** @type {(inputs: Impressum_Copyright_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copyright`)
};

const de_impressum_copyright_title = /** @type {(inputs: Impressum_Copyright_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Urheberrecht`)
};

const fr_impressum_copyright_title = /** @type {(inputs: Impressum_Copyright_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Droit d'auteur`)
};

const es_impressum_copyright_title = /** @type {(inputs: Impressum_Copyright_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Derechos de autor`)
};

const it_impressum_copyright_title = /** @type {(inputs: Impressum_Copyright_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diritto d'autore`)
};

const nl_impressum_copyright_title = /** @type {(inputs: Impressum_Copyright_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Auteursrecht`)
};

const pl_impressum_copyright_title = /** @type {(inputs: Impressum_Copyright_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prawo autorskie`)
};

const fi_impressum_copyright_title = /** @type {(inputs: Impressum_Copyright_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tekijänoikeus`)
};

const da_impressum_copyright_title = /** @type {(inputs: Impressum_Copyright_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ophavsret`)
};

const sv_impressum_copyright_title = /** @type {(inputs: Impressum_Copyright_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Upphovsrätt`)
};

/**
* | output |
* | --- |
* | "Copyright" |
*
* @param {Impressum_Copyright_TitleInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const impressum_copyright_title = /** @type {((inputs?: Impressum_Copyright_TitleInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Impressum_Copyright_TitleInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_impressum_copyright_title(inputs)
	if (locale === "fr") return fr_impressum_copyright_title(inputs)
	if (locale === "es") return es_impressum_copyright_title(inputs)
	if (locale === "it") return it_impressum_copyright_title(inputs)
	if (locale === "nl") return nl_impressum_copyright_title(inputs)
	if (locale === "pl") return pl_impressum_copyright_title(inputs)
	if (locale === "fi") return fi_impressum_copyright_title(inputs)
	if (locale === "da") return da_impressum_copyright_title(inputs)
	if (locale === "sv") return sv_impressum_copyright_title(inputs)
	return en_impressum_copyright_title(inputs)
});